import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import Admin from "@/Admin";
import { StoreProvider } from "@/context/StoreContext";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <StoreProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin/*" element={<Admin />} />
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </StoreProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
